export default [
  {
    name: 'Plus',
    value: 'plus',
    fullname: 'Plus for your practice',
    fees: {
      1: 150,
      2: 150,
      3: 150,
      4: 150,
      5: 150,
      6: 150,
      7: 150,
      8: 150,
      9: 150,
      10: 150,
      11: 200,
      12: 200,
      13: 200,
      14: 200,
      15: 200
    },
    floors: {
      1: 99,
      2: 125,
      3: 125,
      4: 125,
      5: 125,
      6: 150,
      7: 150,
      8: 150,
      9: 150,
      10: 150,
      11: 175,
      12: 175,
      13: 175,
      14: 175,
      15: 175
    },
    annualFloors: {
      1: 1080,
      2: 1275,
      3: 1275,
      4: 1275,
      5: 1275,
      6: 1530,
      7: 1530,
      8: 1530,
      9: 1530,
      10: 1530,
      11: 1785,
      12: 1785,
      13: 1785,
      14: 1785,
      15: 1785
    }
  },
  {
    name: 'Pro',
    value: 'pro',
    fullname: 'Pro for your practice',
    fees: {
      1: 200,
      2: 300,
      3: 300,
      4: 300,
      5: 300,
      6: 500,
      7: 500,
      8: 500,
      9: 500,
      10: 500,
      11: 600,
      12: 600,
      13: 600,
      14: 600,
      15: 600
    },
    floors: {
      1: 150,
      2: 250,
      3: 250,
      4: 250,
      5: 250,
      6: 400,
      7: 400,
      8: 400,
      9: 400,
      10: 400,
      11: 500,
      12: 500,
      13: 500,
      14: 500,
      15: 500
    },
    annualFloors: {
      1: 1620,
      2: 2550,
      3: 2550,
      4: 2550,
      5: 2550,
      6: 4080,
      7: 4080,
      8: 4080,
      9: 4080,
      10: 4080,
      11: 5100,
      12: 5100,
      13: 5100,
      14: 5100,
      15: 5100
    }
  }
]



// WEBPACK FOOTER //
// ./src/data/upgradesfees.js